import OtpFormComponent from './OtpFormContainer';

export default OtpFormComponent;